import {Component, OnInit, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {PassService} from '../../services/pass.service';
import {PassModel} from '../../model/PassModel';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../services/auth.service';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-pass',
    templateUrl: './pass.component.html',
    styleUrls: ['./pass.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, DatePipe]
})
export class PassComponent implements OnInit {

  passwords: Record<string, PassModel[]> = {};
  passwordKeys: string[];
  currentEntry: PassModel = null;

  columns: [{prop: 'name'}, {prop: 'secret'}];

  constructor(
    private passService: PassService,
    private modalService: NgbModal,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.loadData();
  }


  loadData() {
    this.passService.getPasswords().subscribe(res => {
      this.passwords = res;
      this.passwordKeys = Object.keys(res);
    });
  }

  openNew(content: TemplateRef<unknown>) {
    this.currentEntry = {} as PassModel;
    this.openModal(content);
  }

  openEdit(content: TemplateRef<unknown>, edit: PassModel) {
    this.currentEntry = {...edit};
    this.openModal(content);
  }

  openModal(content: TemplateRef<unknown>) {

    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'})
      .result.then(() => this.save());
  }

  showTme(): boolean {
    return this.authService.hasRole('ROLE_ADMIN');
  }

  private save() {
    let observable;
    if (!this.currentEntry.id) {
      observable = this.passService.createPassword(this.currentEntry);
    } else {
      observable = this.passService.updatePassword(this.currentEntry);
    }
    observable.subscribe(res => this.loadData());
  }
}
